// src/components/AsyncEntitySelectDropdown.jsx
import { useState, useEffect, useMemo } from "react";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { EntitySelectDropdown } from "./EntitySelectDropdown";

export function AsyncEntitySelectDropdown({
  fetchOptions,
  queryKey,
  value,
  onChange,
  getOptionValue,
  getOptionLabel,
  fallbackItem = null,
  allLabel = "Все",
  placeholder = "Поиск...",
  disabled = false,
  className = "",
}) {
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // Дебаунс: ждем 300мс после последнего нажатия клавиши
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedSearch(search), 300);
    return () => clearTimeout(handler);
  }, [search]);

  const {
    data: items = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: [...queryKey, debouncedSearch],
    queryFn: () => fetchOptions({ search: debouncedSearch }),
    placeholderData: keepPreviousData,
  });

  const optionsWithFallback = useMemo(() => {
    // Добавляем текущий выбранный элемент, если его нет в поиске,
    // чтобы селект не сбрасывался в "Все", пока грузится поиск.
    if (
      value &&
      value !== "all" &&
      !items.some((i) => getOptionValue(i) === value) &&
      fallbackItem
    ) {
      return [...items, fallbackItem];
    }
    return items;
  }, [items, value, fallbackItem, getOptionValue]);

  if (isError) {
    return <div className="red sm p-2">Ошибка загрузки</div>;
  }

  return (
    <EntitySelectDropdown
      items={optionsWithFallback}
      value={value}
      onChange={onChange}
      getOptionValue={getOptionValue}
      getOptionLabel={getOptionLabel}
      allLabel={allLabel}
      placeholder={isLoading ? "Загрузка..." : placeholder}
      disabled={disabled || isLoading}
      className={className}
      onSearch={setSearch}
      searchable={true}
    />
  );
}
